import { render, staticRenderFns } from "./scrollTop.vue?vue&type=template&id=af1066d4&scoped=true"
import script from "./scrollTop.vue?vue&type=script&lang=js"
export * from "./scrollTop.vue?vue&type=script&lang=js"
import style0 from "./scrollTop.vue?vue&type=style&index=0&id=af1066d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1066d4",
  null
  
)

export default component.exports